import React, { useEffect, useState } from 'react';
import axios from 'axios';
import _ from 'underscore';
import { history } from '../../redux/store';
import setting from '../../config/setting';
import {
  Spin,
  Divider,
  Space,
  Row,
  Col,
  Button,
  Card,
  Form,
  notification,
  Input,
  Select,
  Upload,
  DatePicker,
  message
} from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import moment from 'moment';

const FormItem = Form.Item;
const { Option } = Select;
const { Dragger } = Upload;

const AddDriverQualification = (data) => {
  // const [eventid, setEventid] = useState('123');
  // const [compName, setcompName] = useState('');
  // const [location, setLocation] = useState('');
  // const [employee, setEmployee] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [enableSave, setEnableSave] = useState(false);
  const [LoaderAddDriver, setLoaderAddDriver] = useState(false);
  // const [sex, setSex] = useState('');
  // const [dob, setDob] = useState('');
  // const [email, setEmail] = useState('');
  // const [driver_certifications, setDriverCertification] = useState('');
  // const [commercial_vehicle, setCommercialVehicle] = useState('');
  // const [vehicle_report, setVehicleReport] = useState('');
  // const [perform_history, setPerformHistory] = useState('');
  // const [cargo_edu, setCargoEdu] = useState('');
  // const [road_test, setRoadTest] = useState('');
  // const [fmcsa_training, setFmcsaTraining] = useState('');
  // const [perform_eval, setPerformEval] = useState('');
  // const [cdl_exp, setCdlExp] = useState('');

  const [photo_pdf, setPhotoPdf] = useState([]);
  const [certificateType, setCertificateType] = useState('');
  const [certificateExpiry, setCertificateExpiry] = useState('');
  const [certificateStatus, setCertificateStatus] = useState('');

  const [loader, setLoader] = useState(false);
  const [bool, setBool] = useState(false);
  const [boolNew, setBoolNew] = useState(false);
  const [boolN, setBoolN] = useState(false);
  const [boolNe, setBoolNe] = useState(false);

  const [errors, setErrors] = useState({
    // driver_certifications: '',
    // commercial_vehicle: '',
    // vehicle_report: '',
    // perform_history: '',
    // cargo_edu: '',
    // road_test: '',
    // fmcsa_training: '',
    // perform_eval: '',
    // cdl_exp: '',
    cert_exp: '',
    cert_type: '',
    photo_pdf: ''
  });
  const typeOfCertificate = [
    "Driver's Application",
    "Commercial Driver's License (CDL)",
    'DOT Clearinghouse',
    'Initial Driving Record (MVR)',
    "CDLIS (Commercial Driver's License Information Search)",
    'PSP Search',
    'Previous-Employer Information',
    'Road Test Form and Certificate',
    'DOT Medical Card (Medical Examiner Certificate)',
    'Annual Motor Vehicle Report (MVR)',
    "Driver's Certification of Violations/Annual Review",
    'Entry-level Driver Training Certificate',
    'Longer-combination Vehicle Training Certificate'
  ];
  const typeOfStatus = [
    'Incomplete',
    'Completed',
    'Expired',
    'Cleared',
    'Violation Found',
    'Follow-up Testing',
    'Valid',
    'Suspended',
    'Not Applicable',
    'Revoked',
    'Exempted',
    'Disqualified'
  ];

  useEffect(() => {
    setBool(true);
    setBoolNew(true);
    setBoolN(true);
    setBoolNe(true);
  }, []);

  function addTypeOfCertificate(event) {
    console.log('addTypeOfCertificate type', event);
    setCertificateType(event);

    let errorsCopy = { ...errors };
    errorsCopy['cert_type'] = '';
    setErrors(errorsCopy);
  }
  // function addTypeOfStatus(event) {
  //   console.log('addTypeOfStatus type', event);
  //   setCertificateStatus(event);

  //   let errorsCopy = { ...errors };
  //   errorsCopy['status'] = '';
  //   setErrors(errorsCopy);
  // }

  function addCertificateExpiry(event, date) {
    console.log('addCertificateExpiry Date', date);
    setCertificateExpiry(date);
    let errorsCopy = { ...errors };
    errorsCopy['cert_exp'] = '';
    setErrors(errorsCopy);
  }

  // function addCommercialVehicle(event, date) {
  //   console.log('addCommercialVehicle', date);
  //   setCommercialVehicle(date);
  //   let errorsCopy = { ...errors };
  //   errorsCopy['commercial_vehicle'] = '';
  //   setErrors(errorsCopy);
  // }
  // function addVehicleReport(event) {
  //   console.log('addVehicleReport', event);
  //   setVehicleReport(event);
  //   let errorsCopy = { ...errors };
  //   errorsCopy['vehicle_report'] = '';
  //   setErrors(errorsCopy);
  // }
  // function addPerformHistory(event) {
  //   console.log('addPerformHistory', event.target.value);
  //   setPerformHistory(event.target.value);
  //   let errorsCopy = { ...errors };
  //   errorsCopy['perform_history'] = '';
  //   setErrors(errorsCopy);
  // }
  // function addCargoEdu(event, date) {
  //   console.log('addCargoEdu', date);
  //   setCargoEdu(date);
  //   let errorsCopy = { ...errors };
  //   errorsCopy['cargo_edu'] = '';
  //   setErrors(errorsCopy);
  // }
  // function addRoadTest(event, date) {
  //   console.log('addRoadTest', date);
  //   setRoadTest(date);
  //   let errorsCopy = { ...errors };
  //   errorsCopy['road_test'] = '';
  //   setErrors(errorsCopy);
  // }
  // function addFmcsaTraining(event) {
  //   console.log('addFmcsaTraining', event);
  //   setFmcsaTraining(event);
  //   let errorsCopy = { ...errors };
  //   errorsCopy['fmcsa_training'] = '';
  //   setErrors(errorsCopy);
  // }
  // function addPerformEval(event) {
  //   console.log('addPerformEval', event.target.value);
  //   setPerformEval(event.target.value);
  //   let errorsCopy = { ...errors };
  //   errorsCopy['perform_eval'] = '';
  //   setErrors(errorsCopy);
  // }
  // function addCdlExp(event, date) {
  //   console.log('addCdlExp', date);
  //   setCdlExp(date);
  //   let errorsCopy = { ...errors };
  //   errorsCopy['cdl_exp'] = '';
  //   setErrors(errorsCopy);
  // }

  // function addPhotoPdf(file, fileList) {
  //   console.log('photo_pdf', file);
  //   setPhotoPdf(file);
  //   let errorsCopy = { ...errors };
  //   errorsCopy['photo_pdf'] = '';
  //   setErrors(errorsCopy);
  //   //setPhotoPdf(event.target.files[0]);
  // }

  const saveDriverQualification = (values) => {
    setEnableSave(true);
    console.log(values);
    if (
      values.cert_type &&
      values.cert_exp &&
      // values.status &&
      values.photo_pdf &&
      values.photo_pdf.fileList &&
      values.photo_pdf.fileList.length > 0
      
    ) {
      setLoaderAddDriver(true)
      // setLoaderVaccinated(true);
      const formData = new FormData();
      let employeeData = JSON.parse(localStorage.getItem('employeeInfo'));
      console.log('values.photo pdf :: ', values.photo_pdf);
      if (
        values.photo_pdf &&
        values.photo_pdf.fileList &&
        values.photo_pdf.fileList.length > 0
      ) {
        values.photo_pdf.fileList.map((dat, index) => {
          console.log('dat', dat);
          formData.append('photo_pdf' + index, dat.originFileObj);
        });
      }
    
      formData.append('employee', employeeData.id);
      formData.append('company', employeeData.company[0]);
      formData.append('location', employeeData.emp_location[0]);
      formData.append('sex', employeeData.sex);
      formData.append('dob', moment(employeeData.dob).format('YYYY-MM-DD'));
      formData.append('email', employeeData.email);
      formData.append('first_name', employeeData.first_name);
      formData.append('cert_exp', moment(values.cert_exp).format('YYYY-MM-DD'));
      formData.append('cert_type', values.cert_type);
      // formData.append('status', values.status);

      const headers = {
        'Content-Type': 'multipart/form-data'
      };

      let url = setting.serverUrl + '/api/saveDriverInfo';
      axios({
        method: 'post',
        url: url,
        data: formData,
        headers: headers
      })
        .then((response) => {

          console.log('Respone from saveDriverInfo');
          console.log(response);
          setLoaderAddDriver(false)
          // setLoaderVaccinated(false);
          if (response && response.status === 200) {
            //   if (response.data && response.data.error) {
            //     notification['error']({
            //       message: 'Error',
            //       description: response.data.error
            //     })
            //   }
            setEnableSave(false);
            if (response.data && response.data.success) {
              notification['success']({
                message: 'Success',
                description: 'Information recorded!'
              });
              history.push({ pathname: `/vertical/DriverQualification` });
              //     vaccinatedForm.resetFields();
              //     getCovidVaccinationData();
            }
          } else {
            notification['error']({
              message: 'Error',
              description: 'There is some technical issue. Please try again later.'
            });
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const [driverForm] = Form.useForm();
  return (
    <div style={{ padding: 30 }}>
      <div>
        <Button
          size='small'
          style={{ backgroundColor: 'rgb(61 88 106)', color: 'white', marginTop: 0, padding: 10 }}
          onClick={() => history.goBack()}
        >
          Back
        </Button>
      </div>
      <Row>
        <Col span={8}>
          <h3 style={{ padding: 10, textAlign: 'left' }}>Add driver certificates</h3>
        </Col>
        <Col span={6}></Col>
      </Row>
      {/* <Divider />
       */}
      {bool && boolNew && boolN && boolNe ? (
        <Card style={{backgroundColor:"white"}}>
        <div>
          <Card>
            <Form form={driverForm} onFinish={saveDriverQualification}>
              <br/>
              <div className='row'>
              {/* <div className='col-md-1 col-sm-6'></div> */}
                <div className='col-md-6 col-sm-6'>
                  <div className='col'>
                    <span>Select certificate</span>

                    <FormItem
                      name='cert_type'
                      rules={[{ required: true, message: 'Please select certificate!' }]}
                    >
                      <Select
                        allowClear
                        showSearch
                      
                        onChange={addTypeOfCertificate}
                        optionFilterProp='children'
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
                        }
                      >
                        <Option value=''> Select certificate </Option>
                        {typeOfCertificate.map((cert, i) => (
                          <Option key={i} value={cert}>
                            {cert}
                          </Option>
                        ))}
                      </Select>
                    </FormItem>

                    {/* <span style={{ color: 'red' }}>{errors['cert_type']}</span> */}
                  </div>
                </div>
                <div className='col-md-3 col-sm-6'>
                  <div className='col'>
                    <span>Select Certificate Expiry</span>

                    <FormItem
                      name='cert_exp'
                      rules={[{ required: true, message: 'Please select date!' }]}
                    >
                      <DatePicker
                        allowClear={false}
                        onChange={addCertificateExpiry}
                        style={{ width: '100%', borderRadius: 50, padding: 7 }}
                      />
                    </FormItem>

                    {/* <span style={{ color: 'red' }}>{errors['cert_exp']}</span> */}
                  </div>
                </div>
                <div className='col-md-3 col-sm-6'>
                  <span>Upload Documents</span>

                  <FormItem
                    name='photo_pdf'
                    rules={[
                      {
                        required: true,
                        message: 'Please upload certificate!'
                      }
                    ]}
                  >
                    <Dragger multiple={true}>
                     {/* onChange={addPhotoPdf}> */}
                      <p className='ant-upload-drag-icon'>
                        <InboxOutlined />
                      </p>
                      <p className='ant-upload-text'>Click or drag file to this area to upload</p>
                    </Dragger>
                  </FormItem>
                  {imageUrls &&
                    imageUrls.length > 0 &&
                    imageUrls.map((img) => {
                      return (
                        <p style={{ marginBottom: 10 }}>
                          <a href={img.url} target='_blank'>
                            {img.Key}
                          </a>
                        </p>
                      );
                    })}
                </div>
                {/* <div className='col-md-1 col-sm-6'></div> */}
                </div>
                <br/>
                <div className='row'>
                {/* <div className='col-md-1 col-sm-6'></div> */}
                {/* <div className='col-md-6 col-sm-6'>
                  <div className='col'>
                    <span>Type of status</span>
                    <FormItem
                      name='status'
                      rules={[{ required: true, message: 'Please select status!' }]}
                    >
                      <Select
                        allowClear
                        showSearch
                        onChange={addTypeOfStatus}
                        optionFilterProp='children'
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) === 0
                        }
                      >
                        <Option value=''>Select Dose</Option>
                        {typeOfStatus.map((statusItem, i) => (
                          <Option key={i} value={statusItem}>
                            {statusItem}
                          </Option>
                        ))}
                      </Select>
                    </FormItem>
                    {/* <span style={{ color: 'red' }}>{errors['status']}</span> */}
                  {/* </div>
                </div> */} 
                {/* <div className='col-md-1 col-sm-6'></div> */}
               
                 {/* <div className='col-md-1 col-sm-6'></div> */}
                {/* <i style={{ color: '#1C3A6A', fontWeight: 700 }}>
                  * If you are vaccinated and would like to claim a qualified exemption or
                  vulnerable status, please also fill out the section below.
                </i> */}
                {/* <Divider /> */}
                <FormItem>
                <div className='row'>
                <div className='col-md-6 col-sm-6'></div>
                <div className='col-md-1 col-sm-6'>
                    <Button
                      htmlType='submit'
                      style={{ padding: 20, backgroundColor: '#425a81', color: 'white' }}
                      disabled={enableSave}
                    >
                      Save Record
                    </Button>
                    {LoaderAddDriver &&
                                            <Space size="middle" style={{ marginTop: 20, marginLeft: 30 }}>
                                                <Spin size="large" />
                                            </Space>
                                        }
                    </div>
                    <div className='col-md-5 col-sm-6'></div>
                 </div>
                  {/* {loaderVaccinated && (
                  <Space size='middle' style={{ marginLeft: 20 }}>
                    <Spin size='large' />
                  </Space>
                )} */}
                </FormItem>
              </div>
            </Form>
            {/* <Divider /> */}
            {/* {CovidVaccinationData.length > 0 ? (
            <Table dataSource={CovidVaccinationData} columns={columns} />
          ) : null} */}
          </Card>
        </div>
        </Card>
      ) : (
        <Row>
          <Col span={10}></Col>
          <Col span={8}>
            <Space size='middle' style={{ marginTop: 10 }}>
              <Spin size='large' />
            </Space>
          </Col>
        </Row>
      )}

    </div>
  );
};

export default AddDriverQualification;
